import DayPickerView from './DayPickerView';

export { default as DayPickerView } from './DayPickerView';
export default DayPickerView;